module.exports = __webpack_public_path__ + "static/media/programs.63e3b6f0.svg";